import { supabase } from '../../../lib/supabaseClient';
import { CandidateProfile } from '../types';
import { ApiResponse } from '../../../types/api';
import { handleEdgeFunctionError } from '../../../utils/edgeFunctionUtils';

export async function getCandidateFullProfileWithEdgeFunction(candidateId: string): Promise<ApiResponse<CandidateProfile>> {
  try {
    const { data, error } = await supabase.functions.invoke('get-candidate-full-profile', {
      body: { candidateId },
    });

    if (error) {
      console.error('[Edge Function Error] getCandidateFullProfile:', error);
      const extractedError = await handleEdgeFunctionError(error);
      return { data: null, error: extractedError };
    }

    return { data: data?.data || null, error: data?.error || null };
  } catch (err) {
    console.error('[Edge Function Exception] getCandidateFullProfile:', err);
    return { data: null, error: err };
  }
}
